import React from 'react';
import PropTypes from 'prop-types';
import './CongratsBoxStyles.css';

function CongratsBox({ amount, applicationId, approvalExpires }) {
  return (
    <div className="congrats-box">
      <div className="congrats-title-wrapper">
        <div className="congrats-title">CONGRATULATIONS!</div>
      </div>
      <div className="congrats-amount">You&apos;re approved for up to</div>
      <div className="congrats-amount-value">${amount}</div>
      <div className="congrats-details">
        <div className="congrats-detail-row">
          <div className="congrats-detail-label">APPLICATION ID:</div>
          <div className="congrats-detail-value">{applicationId}</div>
        </div>
        <div className="congrats-detail-row">
          <div className="congrats-detail-label">APPROVAL EXPIRES:</div>
          <div className="congrats-detail-value">{approvalExpires}</div>
        </div>
      </div>
    </div>
  );
}

CongratsBox.propTypes = {
  amount: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  approvalExpires: PropTypes.string.isRequired
};

export default CongratsBox;
